export type SubmitDynamicFormSecurity = {
  honeypotName?: string;
  honeypot?: string;
};

export type SubmitDynamicFormRecipientContext = {
  doctorSlug?: string;
  doctorApiId?: string | number;
};

export async function submitDynamicForm({
  formId,
  values,
  metadata,
  security,
  recipientContext,
}: {
  formId: string;
  values: Record<string, unknown>;
  metadata?: Record<string, unknown>;
  security?: SubmitDynamicFormSecurity;
  recipientContext?: SubmitDynamicFormRecipientContext;
}): Promise<{ status: string }> {
  const body: Record<string, unknown> = { formId, values, metadata };
  if (security) {
    body.security = security;
  }
  if (recipientContext) {
    body.recipientContext = {
      doctorSlug: recipientContext.doctorSlug,
      doctorApiId: recipientContext.doctorApiId,
    };
  }

  const res = await fetch('/api/forms/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const data = await res
      .json()
      .catch(() => ({ message: 'Something went wrong' }));
    throw new Error(data.message || 'Something went wrong');
  }

  return res.json();
}
